
import { requiredTransString } from 'app/views/forms/formTranslations'
import { isFalsy, isTruthy } from 'utilsTS'
import * as Yup from 'yup'
import { budgetCentreGrantKeys } from '../budget/FormBudget'
import { FormBudgetUpdateValue } from './budgetUpdateTypes'
import { isBudgetUpdateChangeEqual } from './formBudgetUpdateUtils'

Yup.addMethod(
  Yup.object, 'checkBudgetUpdateLineValidity',
  function (this: Yup.ObjectSchema) {
    return this.test(
      'checkBudgetUpdateLineValidity',
      requiredTransString,
      function (object) {
        const { path } = this
        const errors: Yup.ValidationError[] = []
        if (object == null) return true

        Object.entries(object).forEach(([key, linesObj]) => {
          const { budgetUpdateChange, applicationBudget } = linesObj
          if (
            isFalsy(budgetUpdateChange) ||
            (isFalsy(budgetUpdateChange.change) && budgetUpdateChange.change !== 0)
          ) {
            errors.push(
              new Yup.ValidationError(
                requiredTransString(),
                null,
                path + `.${key}.budgetUpdateChange.change`
              )
            )
          } else {
            const current = +budgetUpdateChange.change
            const submitted = +applicationBudget.value
            if (
              isTruthy(current) &&
              isFalsy(budgetUpdateChange.changeDetails) &&
              submitted !== current
            ) {
              errors.push(
                new Yup.ValidationError(
                  requiredTransString(),
                  budgetUpdateChange.changeDetails,
                  path + `.${key}.budgetUpdateChange.changeDetails`
                )
              )
            }
          }
        })
        if (errors.length === 0) {
          return true
        }
        const validationError = new Yup.ValidationError('', null, path)
        validationError.inner = errors
        return validationError
      }
    )
  })

Yup.addMethod(Yup.object, 'checkBudgetUpdateActualLineValidity', function (this: Yup.ObjectSchema) {
  return this.test(
    'checkBudgetUpdateActualLineValidity',
    requiredTransString,
    function (object) {
      const { path, parent } = this
      const errors: Yup.ValidationError[] = []
      const thereAreNoChanges = parent.report.hasBudgetChanged === 'No'

      if (thereAreNoChanges) {
        return true
      }
      if (object == null) return true

      Object.entries(object).forEach(([key, linesObj]) => {
        const { budgetUpdateActual } = linesObj
        if (
          isFalsy(budgetUpdateActual) ||
          (isFalsy(budgetUpdateActual.actual) && budgetUpdateActual.actual !== 0)
        ) {
          errors.push(
            new Yup.ValidationError(
              requiredTransString(),
              null,
              path + `.${key}.budgetUpdateActual.actual`
            )
          )
        } else {
          const current = +budgetUpdateActual.actual
          if (
            isTruthy(current) &&
            isFalsy(budgetUpdateActual.actualComments) &&
            !budgetCentreGrantKeys.includes(key)
          ) {
            errors.push(
              new Yup.ValidationError(
                requiredTransString(),
                budgetUpdateActual.actualComments,
                path + `.${key}.budgetUpdateActual.actualComments`
              )
            )
          }
        }
      })
      if (errors.length === 0) {
        return true
      }
      const validationError = new Yup.ValidationError('', null, path)
      validationError.inner = errors
      return validationError
    }
  )
})

Yup.addMethod(Yup.object, 'checkBudgetUpdateTotals', function (this: Yup.ObjectSchema) {
  return this.test('checkBudgetUpdateTotals', '', function (obj) {
    const { path, createError } = this
    const value = obj as FormBudgetUpdateValue | undefined

    if (value == null) return true

    if (!isBudgetUpdateChangeEqual(value.revenuesLines, value.expensesLines)) {
      return createError({
        path,
        message: 'BUDGET_UPDATE_UNEQUAL_EXPENSES_REVENUES_SUMS_LABEL'
      })
    }

    return true
  })
})

export const formBudgetUpdateValidation = (): Yup.ObjectSchema => {
  return Yup.object({
    expensesLines: Yup.object({})
      .checkBudgetUpdateLineValidity()
      .checkBudgetUpdateActualLineValidity(),
    revenuesLines: Yup.object({})
      .checkBudgetUpdateLineValidity()
      .checkBudgetUpdateActualLineValidity()
  }).checkBudgetUpdateTotals()
}
